import { render } from "./StorageOverview.vue?vue&type=template&id=4969ee8b&scoped=true&ts=true"
import script from "./StorageOverview.vue?vue&type=script&lang=ts"
export * from "./StorageOverview.vue?vue&type=script&lang=ts"

import "./StorageOverview.vue?vue&type=style&index=0&id=4969ee8b&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4969ee8b"]])

export default __exports__